import { createContext } from 'react';
import ClientOAuth2 from 'client-oauth2';

export const AuthClientContext = createContext<ClientOAuth2 | null>(null);
